import {checkCircle} from '@sail/icons/react/Icon';
import {TerminalScreen} from 'src/v2/components/screen/TerminalScreen';
import {useSessionContext} from 'src/state/usePayinSessionContext';
import {message, useIntl} from '@sail/intl';

const messages = {
  setupFutureUsageTitle: message({
    id: 'crypto.payins.v2.processing_screen.setup_future_usage_title',
    description: 'Title for processing screen for setup future usage payment',
    defaultMessage: 'Your payment is being processed',
  }),

  setupPaymentMethodTitle: message({
    id: 'crypto.payins.v2.processing_screen.setup_payment_method_title',
    description: 'Title for processing screen for setup payment method',
    defaultMessage: 'Your payment details are being saved',
  }),
};

export const ProcessingScreen = () => {
  const intl = useIntl();
  const {mode} = useSessionContext();

  return (
    <TerminalScreen
      title={intl.formatMessage(
        mode === 'setup'
          ? messages.setupPaymentMethodTitle
          : messages.setupFutureUsageTitle,
      )}
      icon={checkCircle}
      iconCss={{
        color: 'feedback.success',
      }}
      isSuccess
    />
  );
};
